import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import "hammerjs";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { environmentLoader } from "./environments/environmentLoader";

var browser = (function (agent) {
  switch (true) {
    case agent.indexOf("edge") > -1 && agent.indexOf("mobile") > -1:
      return "edgemobile";
    case agent.indexOf("android") > -1:
      return "android";
    case agent.indexOf("fxios") > -1:
      return "firefoxios";
    case agent.indexOf("edge") > -1:
      return "edge";
    case agent.indexOf("opr") > -1:
      return "opera";
    case agent.indexOf("chrome") > -1:
      return "chrome";
    case agent.indexOf("msie") > -1:
    case agent.indexOf("trident") > -1:
      return "ie";
    case agent.indexOf("firefox") > -1:
      return "firefox";
    case agent.indexOf("safari") > -1:
      return "safari";
    default:
      return "other";
  }
})(window.navigator.userAgent.toLowerCase());

function version() {
  var ua = navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: "IE", version: tem[1] || "" };
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: "Opera", version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1],
  };
}

var isIE = browser === "ie";
var isOldFirefox = browser === "firefox" && version().version < 72;
var isOldChrome = browser === "chrome" && version().version < 79;
var isOldEdge = browser === "edge" && version().version < 79;
var isOldEdgeMobile = browser === "edgemobile" && version().version < 44;
var isOldSafari = browser === "safari" && version().version < 12;
var isOldFirefoxIOS = browser === "firefoxios" && version().version < 22;

if (
  isIE ||
  isOldFirefox ||
  isOldEdge ||
  isOldChrome ||
  isOldEdgeMobile ||
  isOldSafari ||
  isOldFirefoxIOS
) {
  document.getElementById("mensaje-obsoleto").style.display = "block";
  document.documentElement.style.height = "100%";
  document.getElementById("body").style.height = "100%";
} else {
  environmentLoader.then((env) => {
    Object.keys(env).forEach((key) => (environment[key] = env[key]));

    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
}
